import {
  Layout,
  HeaderContainer,
  HeaderTitle as LayoutHeaderTitle,
  HeaderSubTitle,
  ContentContainer,
  Content,
  Subtitle,
  FooterContainer,
  FooterPaging,
  FooterSubmit,
} from './Layout';

export {
  Layout,
  HeaderContainer,
  HeaderSubTitle,
  ContentContainer,
  Content,
  FooterContainer,
  FooterPaging,
  FooterSubmit,
  Box,
  Stack,
  Typography,
} from './Layout';

export const EliceLayout = Object.assign(Layout, {
  HeaderContainer,
  HeaderTitle: LayoutHeaderTitle,
  HeaderSubTitle,
  Subtitle,
  ContentContainer,
  Content,
  FooterContainer,
  FooterPaging,
  FooterSubmit,
});

export type { EliceLayoutProps } from './Layout';
